import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Accordion } from "react-bootstrap";
import { GetPageAuthorityFn } from "../../Common/authority";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import http from "../../Common/http-common";
import CssClass from "../../Styles/common.module.css";
import classes from "../../Styles/permission.module.css";
import PDepartment from "../../Components/Users/Permissions/PDepartment";
import PDashboard from "../../Components/Users/Permissions/PLeaveCalendar";
import PLeave from "../../Components/Users/Permissions/PLeave";
import PAllowanceClaim from "../../Components/Users/Permissions/PAllowanceClaim";
import PExpensesClaim from "../../Components/Users/Permissions/PExpensesClaim.js";
import PLeaveHistory from "../../Components/Users/Permissions/PLeaveHistory";
import PAllowanceClaimHistory from "../../Components/Users/Permissions/PAllowanceClaimHistory";
import PExpensesClaimHistory from "../../Components/Users/Permissions/PExpensesClaimHistory";
import PProfile from "../../Components/Users/Permissions/PProfile";
import PEmployee from "../../Components/Users/Permissions/PEmployee";
import PRole from "../../Components/Users/Permissions/PRole";
import PPermission from "../../Components/Users/Permissions/PPermission";
import PSystemPolicy from "../../Components/Users/Permissions/PSystemPolicy";
import PEntitlements from "../../Components/Users/Permissions/PEntitlements";
import PHoliday from "../../Components/Users/Permissions/PHoliday";
import PAllowanceRate from "../../Components/Users/Permissions/PAllowanceRate";
import PEmailNotificationUser from "../../Components/Users/Permissions/PEmailNotificationUser";
import PEmailNotificationLeave from "../../Components/Users/Permissions/PEmailNotificationLeave";
import PEmailNotificationAllowance from "../../Components/Users/Permissions/PEmailNotificationAllowance";
import PEmailNotificationExpenses from "../../Components/Users/Permissions/PEmailNotificationExpenses";
import PEmailNotificationOther from "../../Components/Users/Permissions/PEmailNotificationOther";

const PAGE_NAME = "Permission.js_";
const MODULE_ID = "WEB_URS_004";

const Permissions = (props) => {
  document.title = common.c_TITLE + " - Permission Maintenance";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [allData, setAllData] = useState({
    'Leave Calendar': [], 
    'Leave Application': [], 
    'Allowance Claim': [],
    'Expenses Claim': [],
    'Leave Application History': [],
    'Allowance Claim History': [],
    'Expenses Claim History': [],
    'Profile': [],
    'Employee List': [],
    'Roles': [],
    'Permissions': [],
    'System Policy': [],
    'Entitlements': [], 
    'Gazetted Holidays': [],
    'Allowance Rate': [],
    'Email Notification - User': [], 
    'Email Notification - Leave': [], 
    'Email Notification - Allowance': [], 
    'Email Notification - Expenses': [], 
    'Email Notification - Other': [], 
  });

  const [departmentData, setDepartmentData] = useState({
    'Department': [], 
  });

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const [actionPermission, setActionPermission] = useState({
    READ: "Y",
    WRITE: "Y",
    READALL: "Y",
  });

  useEffect(() => {
    let promise = GetPageAuthorityFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionPermission(result);
        if (result.READ === "N") {
          navigate("/Dashboard");
        }
      },
      (error) => {
        setActionPermission({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
        navigate("/Dashboard");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    let functionName = "";
    const roleDetail = [];

    try {
      functionName = "useEffect Get All Roles";
      onLoadingHandler(true, "Getting Role List, please wait...");

      http
        .get("api/permission/GetAllRole?_user=" + userId, {
          timeout: 10000000,
        })
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              roleDetail.push({
                key: data.ROLE_ID,
                value: data.ROLE_ID,
                label: data.ROLE_NAME,
              });
            });
          }
          setRoleOptions(roleDetail);
        })
        .catch((err) => {
          toast.error("Error on getting role list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
      toast.error("Error on getting role list. Please try again.");
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }, [userId]);

  //#region Event Handlers
  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };
  //#endregion

  const selectRoleHandler = (val) => {
    if (val !== selectedRole) {
      let functionName = "";
      try {
        functionName = selectRoleHandler.name;
        setSelectedRole(val);
        GetFeaturePermissionByID(val.key, "Users")
        .then(() => GetDepartmentByID(val.key, "Department"))
        .then(() => GetFeaturePermissionByID(val.key, "Leave Calendar"))
        .then(() => GetFeaturePermissionByID(val.key, "Leave Application"))
        .then(() => GetFeaturePermissionByID(val.key, "Allowance Claim"))
        .then(() => GetFeaturePermissionByID(val.key, "Expenses Claim"))
        .then(() => GetFeaturePermissionByID(val.key, "Leave Application History"))
        .then(() => GetFeaturePermissionByID(val.key, "Allowance Claim History"))
        .then(() => GetFeaturePermissionByID(val.key, "Expenses Claim History"))
        .then(() => GetFeaturePermissionByID(val.key, "Profile"))
        .then(() => GetFeaturePermissionByID(val.key, "Employee List"))
        .then(() => GetFeaturePermissionByID(val.key, "Roles"))
        .then(() => GetFeaturePermissionByID(val.key, "Permissions"))
        .then(() => GetFeaturePermissionByID(val.key, "System Policy"))
        .then(() => GetFeaturePermissionByID(val.key, "Entitlements"))
        .then(() => GetFeaturePermissionByID(val.key, "Gazetted Holidays"))
        .then(() => GetFeaturePermissionByID(val.key, "Allowance Rate"))
        .then(() => GetFeaturePermissionByID(val.key, "Email Notification - User"))
        .then(() => GetFeaturePermissionByID(val.key, "Email Notification - Leave"))
        .then(() => GetFeaturePermissionByID(val.key, "Email Notification - Allowance"))
        .then(() => GetFeaturePermissionByID(val.key, "Email Notification - Expenses"))
        .then(() => GetFeaturePermissionByID(val.key, "Email Notification - Other"));
      } catch (err) {
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  };

  async function GetFeaturePermissionByID (roleId, moduleName) {
    let functionName2 = "";
    const listItems = [];
    try {
      functionName2 = PAGE_NAME + GetFeaturePermissionByID.name;
      onLoadingHandler(
        true,
        `Getting ${moduleName} feature permission list, please wait...`
      );

      await http
        .get(
          `api/permission/GetFeaturePermissionByID?_user=${userId}&_roleId=${roleId}&_moduleName=${moduleName}`,
          { timeout: 10000000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              var details = [];
              data.PERMISSION_DETAILS.forEach((detail, i) => {
                details.push({
                  key: detail.FEATURE_ID,
                  rowNo: i,
                  FEATURE_ID: detail.FEATURE_ID,
                  FEATURE_TYPE: detail.FEATURE_TYPE,        
                  ROLE_PERMISSION_ID: detail.ROLE_PERMISSION_ID,
                  AUTHORIZED: detail.AUTHORIZED,
                });
              });
              listItems.push({
                key: data.FEATURE_NAME,
                rowNo: counter,
                PERMISSION_DETAILS: details,
                FEATURE_NAME: data.FEATURE_NAME,
                FEATURE_DESC: data.FEATURE_DESC,
                REMARK: data.REMARK,
              });
            });
          }
          setAllData((prevState) => ({
            ...prevState,
            [moduleName]: listItems,
          }));
        })
        .catch((err) => {
          toast.error(
            `Error on getting ${moduleName} feature permission list. Please try again.`
          );
          common.c_LogWebError(PAGE_NAME, functionName2, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      onLoadingHandler(false, "Loading...");
      toast.error(
        `Failed to get ${moduleName} feature permission list. Please try again.`
      );
      common.c_LogWebError(PAGE_NAME, functionName2, err);
    }
  }

  async function GetDepartmentByID (roleId, moduleName) {
    let functionName3 = "";
    const listItems = [];
    try {
      functionName3 = PAGE_NAME + GetDepartmentByID.name;
      onLoadingHandler(
        true,
        `Getting department list, please wait...`
      );

      await http
        .get(
          `api/permission/GetDepartmentbyID?_user=${userId}&_roleId=${roleId}`,
          { timeout: 10000000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems.push({
                key: data.DEPT_NAME,
                rowNo: counter,
                DEPT_ID: data.DEPT_ID,
                DEPT_NAME: data.DEPT_NAME,
                AUTHORIZED: data.AUTHORIZED,
                REMARK: data.REMARK,
              });
            });
          }
          setDepartmentData({ Department: listItems });
        })
        .catch((err) => {
          toast.error(
            `Error on getting department list. Please try again.`
          );
          common.c_LogWebError(PAGE_NAME, functionName3, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      onLoadingHandler(false, "Loading...");
      toast.error(
        `Failed to get department list. Please try again.`
      );
      common.c_LogWebError(PAGE_NAME, functionName3, err);
    }
  }

  function ChangeFeaturePermission(FeatureId, val) {
    let functionName = "";
    try {
      functionName = PAGE_NAME + ChangeFeaturePermission.name;
      onLoadingHandler(true, "Changing authority, please wait...");
      const data = {
        ROLE_ID: selectedRole.key,
        ROLE_NAME: selectedRole.label,
        FEATURE_ID: FeatureId,
        AUTHORIZED: val === true ? "Y" : "N",
        UPDATE_ID: userId,
      };
      http
        .post("api/permission/ChangeFeaturePermission", data, {
          timeout: 10000,
        })
        .then((response) => {
          toast.success(
            `Permission is successfully ${
              val === true ? "inserted" : "removed"
            }.`
          );
        })
        .catch((err) => {
          toast.error(
            `Failed to ${
              val === true ? "insert" : "remove"
            } authority. Please try again.`
          );
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      onLoadingHandler(false, "Loading...");
      toast.error(
        `Failed to ${
          val === true ? "insert" : "remove"
        } authority. Please try again.`
      );
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

  function ChangeDepartmentPermission(DeptId, val) {
    let functionName = "";
    try {
      functionName = PAGE_NAME + ChangeDepartmentPermission.name;
      onLoadingHandler(true, "Changing authority, please wait...");
      const data = {
        ROLE_ID: selectedRole.key,
        ROLE_NAME: selectedRole.label,
        DEPT_ID: DeptId,
        AUTHORIZED: val === true ? "Y" : "N",
        UPDATE_ID: userId,
      };
      http
        .post("api/permission/ChangeDepartmentPermission", data, {
          timeout: 10000,
        })
        .then((response) => {
          toast.success(
            `Permission is successfully ${
              val === true ? "inserted" : "removed"
            }.`
          );
        })
        .catch((err) => {
          toast.error(
            `Failed to ${
              val === true ? "insert" : "remove"
            } authority. Please try again.`
          );
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      onLoadingHandler(false, "Loading...");
      toast.error(
        `Failed to ${
          val === true ? "insert" : "remove"
        } authority. Please try again.`
      );
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

  return (
    <>
      <div style={{ margin: "10px" }}>
        <div style={{ padding: "0 10px" }}>
          <table className="table table-bordered table-hover" style={{ width: isMobile ? '100%' : '48%', border: '1px solid #ccc' }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "middle", width: "20%" }}>
                  Role*
                </td>
                <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
                <td style={{ verticalAlign: "middle", width: "25%" }}>
                  <Comp.Select
                    options={roleOptions}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    allowSelectAll={false}
                    value={selectedRole}
                    onChange={selectRoleHandler}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div style={{ marginLeft: '20px'}}>
        <h4 style={{ fontWeight: 'bold'}}>Department</h4>
        <hr/>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}> 
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Department
                </h5>
                {departmentData["Department"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{departmentData["Department"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PDepartment
                  data={Object.keys(departmentData.length !== 0) && departmentData["Department"].length !== 0 && departmentData["Department"][0].length !== 0
                          ? departmentData["Department"]
                          : []
                        }
                  ChangeDepartmentPermission={ChangeDepartmentPermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <div style={{ marginLeft: '20px'}}>
        <h4 style={{ fontWeight: 'bold'}}>Dashboard</h4>
        <hr/>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}> 
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Leave Calendar
                </h5>
                {allData["Leave Calendar"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Leave Calendar"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PDashboard
                  data={Object.keys(allData.length !== 0) && allData["Leave Calendar"].length !== 0 && allData["Leave Calendar"][0].length !== 0
                          ? allData["Leave Calendar"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <div style={{ marginLeft: '20px'}}>
        <h4 style={{ fontWeight: 'bold'}}>Application</h4>
        <hr/>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap"}}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}> 
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Leave Application
                </h5>
                {allData["Leave Application"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Leave Application"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PLeave
                  data={Object.keys(allData.length !== 0) && allData["Leave Application"].length !== 0 && allData["Leave Application"][0].length !== 0
                          ? allData["Leave Application"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Allowance Claim
                </h5>
                {allData["Allowance Claim"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Allowance Claim"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PAllowanceClaim 
                  data={Object.keys(allData.length !== 0) && allData["Allowance Claim"].length !== 0 && allData["Allowance Claim"][0].length !== 0
                          ? allData["Allowance Claim"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Expenses Claim
                </h5>
                {allData["Expenses Claim"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Expenses Claim"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PExpensesClaim 
                  data={Object.keys(allData.length !== 0) && allData["Expenses Claim"].length !== 0 && allData["Expenses Claim"][0].length !== 0
                          ? allData["Expenses Claim"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

      </div>

      <div style={{ marginLeft: '20px'}}>
        <h4 style={{ fontWeight: 'bold'}}>History</h4>
        <hr/>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Leave Application History
                </h5>
                {allData["Leave Application History"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Leave Application History"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PLeaveHistory
                  data={Object.keys(allData.length !== 0) && allData["Leave Application History"].length !== 0 && allData["Leave Application History"][0].length !== 0
                          ? allData["Leave Application History"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Allowance Claim History
                </h5>
                {allData["Allowance Claim History"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Allowance Claim History"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PAllowanceClaimHistory
                  data={Object.keys(allData.length !== 0) && allData["Allowance Claim History"].length !== 0 && allData["Allowance Claim History"][0].length !== 0
                          ? allData["Allowance Claim History"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Expenses Claim History
                </h5>
                {allData["Expenses Claim History"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Expenses Claim History"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PExpensesClaimHistory
                  data={Object.keys(allData.length !== 0) && allData["Expenses Claim History"].length !== 0 && allData["Expenses Claim History"][0].length !== 0
                          ? allData["Expenses Claim History"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

      </div>

      <div style={{ marginLeft: '20px'}}>
        <h4 style={{ fontWeight: 'bold'}}>Users</h4>
        <hr/>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Profile
                </h5>
                {allData["Profile"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Profile"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PProfile
                  data={Object.keys(allData.length !== 0) && allData["Profile"].length !== 0 && allData["Profile"][0].length !== 0
                          ? allData["Profile"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Employee List
                </h5>
                {allData["Employee List"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Employee List"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PEmployee
                  data={Object.keys(allData.length !== 0) && allData["Employee List"].length !== 0 && allData["Employee List"][0].length !== 0
                          ? allData["Employee List"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Roles
                </h5>
                {allData["Roles"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Roles"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div>
                <PRole
                  data={Object.keys(allData.length !== 0) && allData["Roles"].length !== 0 && allData["Roles"][0].length !== 0
                          ? allData["Roles"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Permissions
                </h5>
                {allData["Permissions"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Permissions"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PPermission
                  data={Object.keys(allData.length !== 0) && allData["Permissions"].length !== 0 && allData["Permissions"][0].length !== 0
                          ? allData["Permissions"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <div style={{ marginLeft: '20px'}}>
        <h4 style={{ fontWeight: 'bold'}}>Master Setup</h4>
        <hr/>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  System Policy
                </h5>
                {allData["System Policy"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["System Policy"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PSystemPolicy
                  data={Object.keys(allData.length !== 0) && allData["System Policy"].length !== 0 && allData["System Policy"][0].length !== 0
                    ? allData["System Policy"]
                    : []
                  }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Entitlements
                </h5>
                {allData["Entitlements"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Entitlements"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PEntitlements
                  data={Object.keys(allData.length !== 0) && allData["Entitlements"].length !== 0 && allData["Entitlements"][0].length !== 0
                    ? allData["Entitlements"]
                    : []
                  }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Allowance Rate
                </h5>
                {allData["Allowance Rate"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Allowance Rate"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PAllowanceRate
                  data={Object.keys(allData.length !== 0) && allData["Allowance Rate"].length !== 0 && allData["Allowance Rate"][0].length !== 0
                        ? allData["Allowance Rate"]
                        : []
                      }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <div style={{ marginLeft: '20px'}}>
        <h4 style={{ fontWeight: 'bold'}}>Public</h4>
        <hr/>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Gazetted Holidays
                </h5>
                {allData["Gazetted Holidays"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Gazetted Holidays"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PHoliday
                  data={Object.keys(allData.length !== 0) && allData["Gazetted Holidays"].length !== 0 && allData["Gazetted Holidays"][0].length !== 0
                        ? allData["Gazetted Holidays"]
                        : []
                      }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <div style={{ marginLeft: '20px'}}>
        <h4 style={{ fontWeight: 'bold'}}>System Apps</h4>
        <hr/>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}> 
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Email Notification - User
                </h5>
                {allData["Email Notification - User"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Email Notification - User"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PEmailNotificationUser
                  data={Object.keys(allData.length !== 0) && allData["Email Notification - User"].length !== 0 && allData["Email Notification - User"][0].length !== 0
                          ? allData["Email Notification - User"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}> 
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Email Notification - Leave
                </h5>
                {allData["Email Notification - Leave"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Email Notification - Leave"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PEmailNotificationLeave
                  data={Object.keys(allData.length !== 0) && allData["Email Notification - Leave"].length !== 0 && allData["Email Notification - Leave"][0].length !== 0
                          ? allData["Email Notification - Leave"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}> 
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Email Notification - Allowance
                </h5>
                {allData["Email Notification - Allowance"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Email Notification - Allowance"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PEmailNotificationAllowance
                  data={Object.keys(allData.length !== 0) && allData["Email Notification - Allowance"].length !== 0 && allData["Email Notification - Allowance"][0].length !== 0
                          ? allData["Email Notification - Allowance"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}> 
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Email Notification - Expenses
                </h5>
                {allData["Email Notification - Expenses"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Email Notification - Expenses"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PEmailNotificationExpenses
                  data={Object.keys(allData.length !== 0) && allData["Email Notification - Expenses"].length !== 0 && allData["Email Notification - Expenses"][0].length !== 0
                          ? allData["Email Notification - Expenses"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}
      >
        <Accordion defaultActiveKey="0" className={classes.accordion}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}> 
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    marginBottom: 0,
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Email Notification - Other
                </h5>
                {allData["Email Notification - Other"]?.length !== 0 && (
                  <i style={{ margin: "0", fontSize: "14px" }}>{allData["Email Notification - Other"][0].REMARK}</i>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PEmailNotificationOther
                  data={Object.keys(allData.length !== 0) && allData["Email Notification - Other"].length !== 0 && allData["Email Notification - Other"][0].length !== 0
                          ? allData["Email Notification - Other"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default Permissions;
